import { action, computed, makeObservable, observable, toJS } from "mobx";
import fetchData from "../utils/fetchData";

export default class GovernanceStore {
  formDataRaw = [];
  dashboardRaw = [];
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      formDataRaw: observable,
      dashboardRaw: observable,
      formData: computed,
      dashboard: computed,
      create: action.bound,
      fetch: action.bound,
      fetchDashboard: action.bound,
    });
  }
  get formData() {
    return toJS(
      this.formDataRaw?.map((ele) => ({
        ...ele,
        group: ele.fieldGroup,
      }))
    );
  }
  get dashboard() {
    return toJS(this.dashboardRaw);
  }
}

GovernanceStore.prototype.create = function ({
  payload,
  update,
  formId,
  showAlert,
  setEditForm,
  navigate,
  totalGroups,
  redirectUrl,
  pageUrl,
  year,
  data,
}) {
  const {
    userStore: { userData },
    companyStore: { companyUnit, kpiId, subCatId, catId },
  } = this.rootStore;
  const token = JSON.parse(
    localStorage.getItem("access-token") ||
      localStorage.getItem("admin-access-token")
  )?.token;
  const formDataPayload = payload?.map((ele) => ({
    ...ele,
    attachment: "",
    year,
    companyUnit,
    kpiId,
    subCatId,
    catId,
    companyId: Number(toJS(userData)?.companyId),
    fieldGroup: ele.group,
  }));
  const formData = new FormData();
  formData.append("data", JSON.stringify(formDataPayload));
  payload.forEach((pay, index) => {
    if (pay?.attachment?.length) {
      for (let i = 0; i < pay.attachment.length; i++) {
        formData.append(`file[]`, pay.attachment[i]);
        formData.append(`index[]`, pay.fieldId);
      }
    }
  });
  fetch(
    process.env.REACT_APP_BASE_URL +
      `governance/${update ? "update" : "create"}${
        formId ? `?formId=${formId}` : ""
      }`,
    {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((res) => res.json())
    .then((response) => {
      if (response.status) {
        showAlert(response.msg, true);
        if (update) {
          setEditForm("");
        }
        if (response?.data?.groupsFilled?.length === data.length) {
          navigate(pageUrl);
          window.location.reload();
          return;
        }
        navigate(pageUrl, {
          state: {
            year: year,
            formId: response.data.formId,
            groupsFilled: response.data.groupsFilled,
            formData: data,
          },
        });
        return;
      }
      showAlert(response.message);
    })
    .catch((err) => {
      showAlert(err.message);
      console.error(err);
    });
};

GovernanceStore.prototype.fetch = function ({ year }) {
  const {
    companyStore: { companyUnit, kpiId, subCatId, catId },
  } = this.rootStore;

  const urlSearchParams = new URLSearchParams({
    companyUnit,
    kpiId,
    subCatId,
    catId,
    year,
  });

  fetchData(`governance/getData?${urlSearchParams.toString()}`)
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
        this.formDataRaw = res.data;
      }
    });
};

GovernanceStore.prototype.fetchDashboard = function ({ year }) {
  // const urlSearchParams = new URLSearchParams({ year });
  const {
    companyStore: { companyUnit },
    dashboardStore: { showAll },

  } = this.rootStore;
  const params = new URLSearchParams();
  params.append("year", year);
  if (!showAll) {
    params.append("companyUnit", companyUnit);
  }
  fetchData(`governance/dashboard?${params.toString()}`)
    .then((res) => res.json())
    .then((res) => {
      if (res.status) {
        this.dashboardRaw = res.data;
      }
    })
    .catch((err) => {
      console.log("[Error]", err);
    });
};
